<!--
 * @Author: 曹捷
 * @Date: 2019-08-19 15:24:34
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-11-08 17:38:08
 * @Description: file content
 -->
<template>
  <a-modal class="obit-modal-default orgadd" :confirm-loading="confirmLoading" :maskClosable="false" :title="showTitle" v-model:visible="open" @cancel="closeDialog" @ok="saveInfo" cancelText="取消"
    okText="确认" width="1080px">
    <a-form :inline="true" :model="formData" :rules="rules" ref="formRef" :label-col="{span: 5}" :wrapper-col="{span:24}">
      <div class="drawing-board">
        <a-col :span="24">
          <p class="title bold">基础信息</p>
        </a-col>
        <a-col :span="12" v-if="detailsInfo.parentId!=='0'">
          <a-form-item label="上级部门" name="parentId">
            <obit-cascader :valueName="pData.id" :label="pData.label" :children="pData.children" :parentId="pData.parentId" :options="orgList" v-model:value="formData.parentId" placeholder="请选择上级部门"
              :changeOnSelect="true">
            </obit-cascader>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="部门名称" name="deptName">
            <a-input :maxlength="20" placeholder="请输入部门全称" show-word-limit v-model:value="formData.deptName"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="排序" name="orderNum">
            <a-input-number id="inputNumber" placeholder="输入序号" v-model:value.number="formData.orderNum" :min="0" :max="999999999999999" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="负责人">
            <a-input :maxlength="20" placeholder="请输入姓名" show-word-limit v-model:value="formData.leader"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="联系电话">
            <a-input :maxlength="20" placeholder="输入电话" show-word-limit v-model:value="formData.phone"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="部门状态" name="status">
            <obit-dict dictCode="sys_normal_disable" type="radio" v-model:value="formData.status">
            </obit-dict>
          </a-form-item>
        </a-col>
      </div>
    </a-form>
  </a-modal>
</template>
<script>
import { computed, inject, onMounted, reactive, toRefs } from 'vue'
import { util } from 'obit-wui'
export default {
  props: {
    open: {
      type: Boolean
    },
    addType: {
      type: String,
    },
    detailsInfo: {
      type: Object,
    },
  },
  setup (props, context) {
    let http = inject('http')
    let _data = reactive({
      formData: {},
      formRef: null,
      orgList: {},
      confirmLoading: false,
      pData: { label: 'label', id: 'id', children: 'children', parentId: 'parentId' },
      rules: {
        deptName: [
          { required: true, message: '请输入排序', trigger: 'blur', },
        ],
        orderNum: [
          { required: true, message: '请输入排序', }
        ],
        status: [
          { required: true, message: '请输入排序', trigger: 'check', }
        ],
      },
    })
    let _computed = {
      showTitle: computed(() => props.addType === 'add' ? '新增部门' : '修改部门')
    }
    let _methods = {
      saveInfo () {
        _data.formRef.validate().then(() => {
          let param = util.util.cloneObj(_data.formData)
          _data.confirmLoading = true
          if (props.addType === 'add') {
            http.sysPost('system/dept/add', param).then((res) => {
              context.emit('reload')
              _methods.closeDialog()
            }).catch(() => {
              _data.confirmLoading = false
            })
          } else {
            http.sysPost('system/dept/edit', param).then((res) => {
              context.emit('reload')
              _methods.closeDialog()
            }).catch(() => {
              _data.confirmLoading = false
            })
          }

        })
      },
      closeDialog () {
        util.util.cleanObj(_data.formData)
        context.emit('update:open', false)
      },
      handleSearch (value) {
        _data.handleChange(value);
      },
      handleChange (value) {
        _data.formData.parentId = value != null && value != '' ? value : [];
      },
      handleBlur (value) {
        _data.formData.parentId = value;
        if (_data.list.indexOf(value) == -1) {
          _data.list.push(value);
        }
      },
    }
    onMounted(() => {
      _data.formData = util.util.cloneObj(props.detailsInfo)
      console.log('🚀 ~ file: orgAdd.vue ~ line 147 ~ onMounted ~ props.detailsInfo', props.detailsInfo)
      if (props.addType === 'add') {
        _data.formData.orderNo = 0
        _data.formData.status = '0'
      }
      _data.orgList = []
      http.sysGetTreeSelect().then(data => {
        _data.orgList = util.util.cloneObj(data)
      })
    })
    return {
      ..._computed,
      ...toRefs(_data),
      ..._methods
    }
  },
}
</script>
<style lang="less">
.orgadd {
  .ant-input-number {
    width: 100%;
  }
}
</style>